<div class="selectDropdown select-categorised" [ngStyle]="{ width: isMobile ? 'unset' : '520px' }">
  <pp-hide-dropdown (ppHideDropdown)="hideDropdown()"></pp-hide-dropdown>

  <ul class="dropdownWrapper dropdownWrapper--grouped">
    @for (category of items; let idx = $index; track idx) {
      <li class="select-categorised__container">
        <p class="select-categorised__label">
          <span>{{ category.label | ppTranslate }}</span>
          <pp-info-icon
            ppClass="displayFlex"
            [ppTitle]="category.description | ppTranslate"
            ppTooltip
          />
        </p>

        <ul class="select-categorised__options">
          @for (item of category.items; track item.label) {
            <pp-select-categorised-dropdown-item
              [ppItem]="item"
              (onClick)="selectItem(item)"
              [ppIsSelected]="false"
            />
          }
        </ul>
      </li>
    }
  </ul>
</div>
